import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {formatDate} from "../utils/formatDate.js";
import {
  headPrimaryColor,
  headSecondColor,
  mainHeaderbg,
  headColor,
} from "../components/ThemeConfig/headerConfig";
import { useHeaderDynamicStyles } from "../components/useDynamic/header_DynamicStyle";
import { setTimeOutSync } from "../utils/setTimeout";
import { fetchUserDataList, fetchProfileDataList } from "../api/User_api";
import ProfileIcon from "../components/profileIcon/ProfileIcon.js";
function Header({ parentmenu }) {
  useHeaderDynamicStyles(
    headPrimaryColor,
    headSecondColor,
    mainHeaderbg,
    headColor
  );
  const navigate = useNavigate();

  const handleProfile = () => {
    navigate("/infoProfile");
  };

  const [dataProfile, setDataProfile] = useState({
    firstname: null,
    lastname: null,
    rolename: null,
    lastlogin: null,
  });

  const [isLoading, setLoading] = useState(false);

  async function getDataProfile() {
    try {
      setLoading(true);
      // setTimeOutSync(() => setLoading(false)).then(async () => {
        let response = await fetchProfileDataList();
        setDataProfile({
          ...dataProfile,
          firstname: response.firstname,
          lastname: response.lastname,
          rolename: response.role.role_name,
          lastlogin: formatDate(response.last_login),
        });
      // });
    } catch (error) {

    }
  }

  useEffect(() => {
    getDataProfile();
  }, []);

  return (
    <nav className="main-header navbar navbar-expand navbar-Template navbar-light">
      {/* Left navbar links */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <Link
            as={Link}
            className="nav-link"
            data-widget="pushmenu"
            role="button"
          >
            <i className="fas fa-bars" />
          </Link>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <p className="nav-link fontReg font-size02 colorGray01 d-flex align-items-center m-0">
            {/* <p>
              {" "}
              H1 dd<sub>2</sub>SO<sub>4</sub>
              <sub>2</sub> is chemical formula for sulphuric acid.
            </p> */}
            {parentmenu}
          </p>
        </li>
      </ul>
      {/* Right navbar links */}
      <ul className="navbar-nav ml-auto">
        <li className="nav-item d-flex align-items-center">
          <div className="row">
            <div className="col-12">
              <div className="colorGray01 font-weight-light text-right">
                <span className="fontReg font-size02 line-height05">
                  {dataProfile?.firstname} &nbsp; {dataProfile?.lastname}
                </span>
              </div>
            </div>
            <div className="col-12 mgt01">
              <div className="colorGray01 text-right">
                <span className="fontReg font-size03 line-height05">
                  {dataProfile?.rolename}
                </span>
              </div>
            </div>
            <div className="col-12 mgt01">
              <div className="colorGray01 text-right">
                <span className="fontReg font-size03 line-height05">
                  Last log on : {dataProfile?.lastlogin}
                </span>
              </div>
            </div>
          </div>
        </li>
        {/* Profile Dropdown Menu */}
        <li className="nav-item nav-profile">
          <div className="dropdown">
            <button
              className="nav-link count-indicator bg-transparent btn btn-primary dropdown-toggle arrowDown-pf"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <ProfileIcon firstCharacter={dataProfile?.firstname?.charAt(0)} className={`profile-sty01`} />
            </button>
            <div
              className="dropdown-menu dropdown-menu-right fontReg font-size01 line-height03"
              aria-labelledby="dropdownMenuButton"
            >
              <button onClick={() => handleProfile()} className="dropdown-item">
                Profile
              </button>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default Header;
